export var BiasingStrategyFieldNames;
(function (BiasingStrategyFieldNames) {
    BiasingStrategyFieldNames["Name"] = "name";
    BiasingStrategyFieldNames["DefineBiasItems"] = "defineBiasItems";
    BiasingStrategyFieldNames["Tags"] = "tagList";
    BiasingStrategyFieldNames["CreatedByEmail"] = "createdByEmail";
    BiasingStrategyFieldNames["ModifiedByEmail"] = "modifiedByEmail";
})(BiasingStrategyFieldNames || (BiasingStrategyFieldNames = {}));
export const DEFAULT_RELEVANCY = 'defaultRelevancy';
export const defaultFormValues = {
    [BiasingStrategyFieldNames.Name]: '',
    [BiasingStrategyFieldNames.Tags]: [],
    [BiasingStrategyFieldNames.DefineBiasItems]: [
        {
            attributeName: '',
            influenceSliderValue: 4,
            matches: '',
            numericContents: [],
            type: undefined,
        },
    ],
};
export const FULL_COLUMN_WIDTH = 12;
export const HALF_COLUMN_WIDTH = 6;
export const ONE_COLUMN_WIDTH = 4;
